import { createContext, useContext, type ReactNode } from "react";
import type { Socket } from "socket.io-client";
import { useCommunitySocket } from "@/realtime/useCommunitySocket";

type CommunitySocketContextValue = {
  socket: Socket | null;
  isConnected: boolean;
  joinCourse: (courseId: string) => Promise<{ communityId: string; courseId: string }>;
  sendPost: (
    payload: {
      courseId: string;
      content: string;
      parentId?: string | null;
      attachmentUrl?: string | null;
      attachmentType?: "IMAGE" | "VIDEO" | "PDF" | "AUDIO" | null;
    },
  ) => Promise<any>;
};

const CommunitySocketContext = createContext<CommunitySocketContextValue | null>(null);

export function CommunitySocketProvider({ children }: { children: ReactNode }) {
  const value = useCommunitySocket();
  return (
    <CommunitySocketContext.Provider value={value as unknown as CommunitySocketContextValue}>
      {children}
    </CommunitySocketContext.Provider>
  );
}

export function useCommunitySocketContext() {
  const ctx = useContext(CommunitySocketContext);
  if (!ctx) throw new Error("useCommunitySocketContext must be used within CommunitySocketProvider");
  return ctx;
}

